/* eslint-disable eqeqeq */
import React, {useState, useEffect} from 'react'
import {Worker} from '@react-pdf-viewer/core'
import {Viewer} from '@react-pdf-viewer/core'
import {defaultLayoutPlugin} from '@react-pdf-viewer/default-layout'
import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

const BuilderPage: React.FC = () => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin()
  const [roleUser, setRoleUser] = useState('')

  useEffect(() => {
    const role = () => {
      const role: any = localStorage.getItem('role-flag')
      setRoleUser(role)
    }
    role()
  }, [])

  return (
    <>
      <div className='card'>
        <div className='card-body'>
          {roleUser == 'salesAdmin' ? (
            <Worker workerUrl='https://unpkg.com/pdfjs-dist@3.3.122/build/pdf.worker.min.js'>
              <Viewer fileUrl='./retail-salespi.pdf' plugins={[defaultLayoutPluginInstance as any]} />
            </Worker>
          ) : roleUser == 'salesAnper' || roleUser == 'Otorisator ' ? (
            <Worker workerUrl='https://unpkg.com/pdfjs-dist@3.3.122/build/pdf.worker.min.js'>
              <Viewer fileUrl='./retail-anper.pdf' plugins={[defaultLayoutPluginInstance as any]} />
            </Worker>
          ) : (
            <Worker workerUrl='https://unpkg.com/pdfjs-dist@3.3.122/build/pdf.worker.min.js'>
              <Viewer fileUrl='./retail-test.pdf' plugins={[defaultLayoutPluginInstance as any]} />
            </Worker>
          )}
        </div>
      </div>
    </>
  )
}

export {BuilderPage}
